"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AddressModel {
    constructor(label, address) {
        this.label = '';
        this.city = '';
        this.postalCode = '';
        this.state = '';
        this.stateCode = '';
        this.street = '';
        this.country = '';
        this.countryCode = '';
        this.county = '';
        this.label = label;
        if (address) {
            this.street = address.street;
            this.city = address.city;
            this.state = address.state;
            this.stateCode = address.stateCode;
            this.postalCode = address.postalCode;
            this.county = address.county;
            this.country = address.country;
            this.countryCode = address.countryCode;
        }
    }
    // check if address is an empty string
    get isSet() {
        return this.toString().replace(/ /g, '').length > 0;
    }
    toString() {
        const values = [
            this.street,
            this.city,
            this.state,
            this.postalCode
        ];
        if (typeof values[0] === 'string' && values[0].length > 0) {
            values.splice(1, 0, ',');
        }
        return values.join(' ').replace(' ,', ',');
    }
}
exports.AddressModel = AddressModel;
//# sourceMappingURL=address.model.js.map